
import { defineComponent } from 'vue';
import Icon from '@/components/content/Icon.vue';
import Button from '@/components/form/Button.vue';

export default defineComponent({
  name: 'RecordButton',
  components: { Icon, Button },
  props: {
    icon: {
      type: String,
      default: '',
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
});
